<template>
	<div class="l-body">
		<top/>
	<!-- <div class="header">
	<div class="l-wrap">
	<a class="header__logo" href="https://www.zhaouc.com/" target="_blank">塔人网络</a>
	<el-dropdown class="news_nav">
		<span>
			游戏充值
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item><a href="http://pay.tarenwang.com/" target="_blank">MU、SUN</a></el-dropdown-item>
		    <el-dropdown-item><a href="http://trpay.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<el-dropdown class="news_nav">
		<span>
			帐号管理
		</span>
		<el-dropdown-menu slot="dropdown">
		    <el-dropdown-item><a href="http://yht.zhaouc.com/" target="_blank">MU、SUN</a></el-dropdown-item>
		    <el-dropdown-item><a href="http://roinfo.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<a class="news_nav" href="http://www.zhaouc.com/" target="_blank">塔人主站</a>
	<a class="news_nav" href="/">客服首页</a>
	</div>
	</div> -->
	<div class="wrap login_bg">
	<div class="login zheng">
	<div class="login_dl">
	<div class="login_box">
	<h1>奇迹MU(VIP区)登录</h1>
	                        <div id="login_frame" class="login_frame">
	                            <form id="form" class="login_form" name="form">
	                                <div class="login_table">
	                                    <!-- 用户信息填写表单 -->
	                                    <div id="tbody_user" class="tbody" style="position: relative">
	                                        <!-- 用户名 -->
	                                        <div id="user_name" class="tr">
	                                            <div id="user_name_input" class="cell_input with_icon">
	                                                <span class="td">
	                                                  <input type="text" id="account" name="account" tabindex="1" class="text username" maxlength="50" placeholder="手机/邮箱/个性账号" autocomplete="off" v-model="name">
	                                                </span>
	                                            </div>
	                                        </div>
	                                        <!--用户名 -->

	                                        <!-- 密码 -->
	                                        <div id="user_pwd" class="tr">
	                                            <div id="user_pwd_input" class="cell_input with_icon">
	                                                <span class="td">
	                                                  <input type="password" tabindex="2" id="password" autocomplete="off"  name="password" class="text password" maxlength="40" placeholder="账号密码" v-model="poss">
	                                                </span>
	                                            </div>
	                                        </div><!--密码 -->

											                    <div id="user_code" class="tr" >
                                            <div class="form_tips" style="display: block;background:#eee;line-height:2;padding:0 10px"  @click="flash">刷新验证码</div>
                                            <div class="form-group" style="margin:10px 0" >
                                              <div id="embed-captcha">
                                                <div id="wait" class="show">正在加载验证码......</div>
                                                <div id="notice" class="hide">请先完成验证</div>
                                              </div>
                                            </div>
	                                        </div><!--密码 -->

	                                    </div>
	                                    <!--用户名 -->
										<div class="no_reg">
	                                        <div class="ui_btn ui_btn_gray">
	                                          <div style="float:left">
	                        <el-checkbox v-model="chk">记住密码</el-checkbox>
	                    </div>

	                                        </div>
	                                    </div>

	                                    <!-- 表单提交按钮 -->
	                                    <div id="tbody_btn" class="tbody" >
	                                        <div id="login_btn" class="tr">
	                                            <div class="login_btn">
	                                                <span class="td">
	                                                    <input class="submit_btn" id="submit" tabindex="40" value="登 录" @click="sub()">
	                                                    <div style="clear:both"></div>
	                                                </span>
	                                            </div>
	                                        </div>
	                                    </div>
	                                    <!--表单提交按钮 -->
	                                </div>
	                            </form>
	                        </div>
	                    </div>
	</div>
	</div>
	</div>
	</div>
</template>

<script>
	import top from '@/components/top1.vue'
	export default {
	  name: 'vlogin',
	  components: {
	    top
	  },
	  data () {
	    return {
		name:'',
		poss:'',
		chk:false
	    }
	  },
    mounted(){
    window.geetResetAjax();
	this.getLs();
    },
    methods:{
      flash(){
        window.geetResetAjax();
      },
		sub(){
			if(this.name.length==0){
				this.$message({
				  type: 'error',
				  message: '用户名不能为空！',
				  offset:300
				});
				return false;
			}
			if(this.poss.length==0){
				this.$message({
				  type: 'error',
				  message: '密码不能为空！',
				  offset:300
				});
				return false;
			}
            // @ts-ignore
            var isverify = $('.geetest_success_radar_tip_content').html();
            if (isverify != '验证成功') {
              this.$message({
                type: 'error',
                message: '验证码不正确！',
				offset:300
              });
              return false;
            }
            this.$axios({
              method: 'post',
              url: '/index.php/user/User/viplogin',
              data: {
                name:this.name,
                password:this.poss,
                geetest_challenge:$("input[name='geetest_challenge']").val(),
                geetest_validate:$("input[name='geetest_validate']").val(),
                geetest_seccode:$("input[name='geetest_seccode']").val()
              }
            }).then(res => {
              console.log(res.data)
              if(res.data.status==200){
				  if (this.chk == true) {
				  	const info = { name: this.name, poss:this.poss};
				  	localStorage.setItem('cook', JSON.stringify(info));
				  }else {
				  	localStorage.clear();
				  }
                this.$router.push({path:"/"})
              }else {
                this.$message({
                  type: 'error',
                  message: res.data.data.data,
				  offset:300
                });
              }
            })
	    },
		getLs() {
			var data1 = JSON.parse(localStorage.getItem('cook'));
			if(data1&&data1.name){
				this.name=data1.name
				this.poss=data1.poss
			}
		}
	  }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/vlogin.vue